const SOURCE = {
  EVTOOLS: 'evtools',
  GOOGLE: 'Google',
  ECO_MOVEMENT: 'import-eco-movement',
  MANUAL: 'Manual',
  MRAE: 'import-mrae',
  VATTENFALL: 'import-vattenfall',
  DEN_BOSCH: 'import-den-bosch',
  GRONINGEN: 'import-groningen',
  RHDHV: 'import-royal-haskoning',
  LPN: 'import-lpn',
  OVERMORGEN: 'import-overmorgen',
  SPOL: 'import-spol',
  AMSTERDAM: 'import-amsterdam',
  NDW: 'NL-NAP-NDW',
  WORKFLOW: 'workflow',
  API: 'api',
  PARTICIPATION: 'participation',
  BUCH_GEMEENTEN: 'import-buch-gemeenten',
  DASHBOARD: 'import-dashboard',
  FILE: 'file',
  EVMAPS: 'ev-maps',
}

const SOURCE_LABELS = {
  [SOURCE.EVTOOLS]: 'EVtools',
  [SOURCE.GOOGLE]: 'Google Geocoder resultaat',
  [SOURCE.ECO_MOVEMENT]: 'Import Eco-Movement',
  [SOURCE.MANUAL]: 'Handmatige invoer',
  [SOURCE.MRAE]: 'Import MRA-E',
  [SOURCE.VATTENFALL]: 'Import Vattenfall',
  [SOURCE.DEN_BOSCH]: 'Import Gemeente Den Bosch',
  [SOURCE.GRONINGEN]: 'Import Gemeente Groningen',
  [SOURCE.RHDHV]: 'Import Royal HaskoningDHV',
  [SOURCE.LPN]: 'Import Laadpaal Nodig',
  [SOURCE.OVERMORGEN]: 'Import Overmorgen',
  [SOURCE.SPOL]: 'Import SPOL',
  [SOURCE.AMSTERDAM]: 'Import (VOLT) plankaart Amsterdam',
  [SOURCE.NDW]: 'Import NDW (NL-NAP)',
  [SOURCE.WORKFLOW]: 'Workflow',
  [SOURCE.API]: 'API',
  [SOURCE.PARTICIPATION]: 'Participatie',
  [SOURCE.BUCH_GEMEENTEN]: 'Import BUCH Gemeenten',
  [SOURCE.DASHBOARD]: 'Import via Dashboard',
  [SOURCE.FILE]: 'File',
  [SOURCE.EVMAPS]: 'EV Maps',
}

const SOURCES = Object.values(SOURCE)

/**
 * Location sources that are hidden on the map by default (Legend > Locatiebronnen).
 * Every other source is shown. A visibility choice made by the user takes priority.
 */
const SOURCES_HIDDEN_BY_DEFAULT = [SOURCE.NDW]

const SOURCE_TYPE = {
  DASHBOARD: 'import-dashboard',
  FILE: 'file',
  API: 'api',
}

const getSourceLabel = (source) => {
  if (!source || !SOURCE_LABELS[source]) return ''
  return SOURCE_LABELS[source]
}

module.exports = {
  SOURCE,
  SOURCES,
  SOURCES_HIDDEN_BY_DEFAULT,
  SOURCE_TYPE,
  getSourceLabel,
}
